<template>
	<el-tooltip
		popper-class="rp-tooltip-style"
		effect="dark"
		:content="displayContent"
		placement="top-end"
	>
		<i @click="clickedIcon" class="el-icon-copy-document"></i>
	</el-tooltip>
</template>
<script>
export default {
    props: {
        visibleText: String,
        textAfterClick: String,
        afterTextTimeSpan: Number //milli seconds
    },

    data() {
        return {
            displayContent: '',
            timer: 0,
        }
    },

    mounted() {
        this.displayContent = this.visibleText
    },

    methods: {
        clickedIcon() {
            if(this.timer) {
                clearTimeout(this.timer)
            }
            this.displayContent = this.textAfterClick;
            this.timer = setTimeout(()=> {
                this.displayContent = this.visibleText 
            }, this.afterTextTimeSpan)
        }
    }
}
</script>
